export const LOAD_WEEKDAYS = 'LOAD_WEEKDAYS'
export const LOAD_COMPANY_WORKDAYS = 'LOAD_COMPANY_WORKDAYS'
export const ADD_WEEKDAY_ENUM = 'ADD_WEEKDAY_ENUM'
